export const VIEW_DISPO = 'VIEW_DISPO';
export const VIEW_ALL = 'VIEW_ALL';
export const VIEW_PLACER = 'VIEW_PLACER';
export const VIEW_OF_PAGE = 'VIEW_OF_PAGE';
export const ACTIONS_VIEWS = [
  { key: VIEW_DISPO, libelle: `editCheminFer.actions.${VIEW_DISPO}` },
  { key: VIEW_ALL, libelle: `editCheminFer.actions.${VIEW_ALL}` },
  { key: VIEW_PLACER, libelle: `editCheminFer.actions.${VIEW_PLACER}` },
  { key: VIEW_OF_PAGE, libelle: `editCheminFer.actions.${VIEW_OF_PAGE}` },
];
export const COEFFICIENT_DIMENSION = (96 / 25.4);
export const SCALE_MAX = 80;
export const SCALE_MIN = 60;
